// Research.jsx
import React, { useState } from 'react';
import './Research.css';

const Research = () => {

  // -------- Tab Navigation State --------
  const [activeTab, setActiveTab] = useState("publications");

  // -------- Research Publications (Merged & Cleaned) --------
  const publications = [
    {
      id: 1,
      title: "Forecasting Capital Market Volatility: A Comparison Among GARCH Family of Models",
      authors: "Sarangi, Prasant, Dublish, S. and Ankur Srivastava",
      journal: "Finance India",
      volume: "Vol. XXIX, No.2",
      year: "June 2015",
      category: "Finance"
    },
    {
      id: 2,
      title: "Choosing an Appropriate Model for Estimating Mentha Oil Future Return Volatility",
      authors: "Ankur Srivastava and Sarangi, Prasant",
      journal: "International Journal of Marketing, Financial Services & Management Research",
      volume: "Vol. 4, No. 1",
      year: "Jan-March 2015",
      category: "Commodities"
    },
    {
      id: 3,
      title: "Estimating Volatility in Crude Oil Futures Market with Asymmetric GARCH Specifications",
      authors: "Ankur Srivastava and Sarangi, P.",
      journal: "Asian Journal of Research in Business Economics and Management",
      volume: "Vol. IV, Issue VI",
      year: "June 2014",
      category: "Energy"
    },
    {
      id: 4,
      title: "Choosing A Suitable GARCH Specification for Predicting the Crude Oil Future Return",
      authors: "Ankur Srivastava and Sarangi, P.",
      journal: "International Journal of Scientific Research",
      volume: "Vol-3, No-5",
      year: "May 2014",
      category: "Energy"
    },
    {
      id: 5,
      title: "Are GARCH Specifications Superior Among GARCH Types? An Experiment",
      authors: "Ankur Srivastava and Sarangi, P.",
      journal: "Apeejay-Journal of Management Sciences and Technology",
      volume: "Vol.-1, Issue-2",
      year: "February 2014",
      category: "Finance"
    },
    {
      id: 6,
      title: "Forecasting Performances of GARCH Family of Models",
      authors: "Sarangi, P., Dublish, S. and Ankur Srivastava",
      journal: "Apeejay-Journal of Management Sciences and Technology",
      volume: "Vol.-1, Issue-1",
      year: "October 2013",
      category: "Finance"
    }
  ];

  // -------- Conference Presentations (Merged) --------
  // -------- Conference Presentations & Workshops (Merged + Chronological) --------
  const presentations = [
    {
      id: 1,
      title: "Changing Paradigm of Management Practices in Emerging Markets: Challenges and Opportunities",
      event: "One Day National Seminar",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "April 22, 2016",
      type: "Seminar"
    },
    {
      id: 2,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "March 17, 2016",
      type: "Workshop"
    },
    {
      id: 3,
      title: "Budget Session for MBA Students",
      event: "Academic Event",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "March 03, 2016",
      type: "Session"
    },
    {
      id: 4,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "Raj Kumar Goel Institute of Technology, Ghaziabad",
      date: "February 22, 2016",
      type: "Workshop"
    },
    {
      id: 5,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "Institute of Advance Management & Research, Ghaziabad",
      date: "February 22, 2016",
      type: "Workshop"
    },
    {
      id: 6,
      title: "Money Management Skills & Career Opportunities in Finance",
      event: "Workshop",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "October 13, 2015",
      type: "Workshop"
    },
    {
      id: 7,
      title: "Innovative Management Practices for Corporate Success",
      event: "One Day National Seminar",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "September 04, 2015",
      type: "Seminar"
    },
    {
      id: 8,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "JRE Group of Institutions, Greater Noida",
      date: "March 25, 2015",
      type: "Workshop"
    },
    {
      id: 9,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "February 25, 2015",
      type: "Workshop"
    },
    {
      id: 10,
      title: "Financial Literacy Workshop for Young Investors",
      event: "SEBI Sponsored Program",
      venue: "Apeejay School of Management, Greater Noida",
      date: "February 06, 2015",
      type: "Workshop"
    },
    {
      id: 11,
      title: "Emerging Trends in SCM and Its Impact on Industry",
      event: "One Day National Seminar",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "August 30, 2014",
      type: "Seminar"
    },
    {
      id: 12,
      title: "Examining the Superiority of GARCH (p, q) Specifications",
      event: "International Conference on Emerging Trends in Global Management Practices",
      venue: "Symbiosis Centre for Management Studies, Noida",
      date: "March 7-8, 2014",
      type: "Conference"
    },
    {
      id: 13,
      title: "Scope of Financial Services and their Importance in Management Education",
      event: "One Day AICTE Approved National Seminar",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "August 30, 2013",
      type: "Seminar"
    },
    {
      id: 14,
      title: "Managing Challenges in HRM after Globalization",
      event: "One Day AICTE Approved National Seminar",
      venue: "I.T.S Engineering College, Greater Noida",
      date: "October 05, 2012",
      type: "Seminar"
    },
    {
      id: 15,
      title: "Managing Challenges in Service Marketing",
      event: "One Day AICTE Approved National Seminar",
      venue: "ITS Engineering College, Greater Noida",
      date: "March 27, 2012",
      type: "Seminar"
    },
    {
      id: 16,
      title: "Emergence of Commodity Market in India and Its Future Prospects",
      event: "Faculty Development Program (FDP)",
      venue: "RKGIT, Ghaziabad",
      date: "May 10, 2006",
      type: "FDP"
    },
    {
      id: 17,
      title: "Personal Excellence – Parivartan",
      event: "Workshop",
      venue: "Raj Kumar Goel Institute of Technology, Ghaziabad",
      date: "Dec 27, 2004 – Jan 05, 2005",
      type: "Workshop"
    }
  ];

  // -------- Experience (Extracted from PDF) --------
  const fdpData = [
    {
      id: 1,
      title: "Nxt-Level Skills for Nxt-Gen Educators",
      theme: "Applied Data Science & AI: From Raw Data to Interactive Insights",
      organizer: "upGrad Elevate",
      type: "Faculty Enrichment Program",
      mode: "Online",
      duration: "1 Day",
      date: "July 05, 2025",
      category: "AI & Data Science"
    },
    {
      id: 2,
      title: "Teaching in the Age of AI",
      organizer: "IMARTICUS LEARNING",
      collaboration: "Skill India & NSDC",
      type: "Faculty Development Program",
      mode: "Online",
      duration: "1 Day",
      date: "July 05, 2025",
      category: "Artificial Intelligence in Education"
    },
    {
      id: 3,
      title: "Reimagining Higher Education with Indian Knowledge Systems",
      organizer: "Lloyd Group of Institutions, Greater Noida",
      collaboration: "California State University, San Bernardino",
      type: "Faculty Development Program",
      mode: "Online",
      duration: "3 Days",
      date: "March 06–08, 2025",
      category: "Higher Education & IKS"
    },
    {
      id: 4,
      title: "Financial Modelling – A Tool for Decision Making",
      organizer: "Sri Balaji University, Pune",
      sponsor: "ATAL–AICTE",
      type: "Faculty Development Program",
      mode: "Offline",
      duration: "1 Week",
      date: "Nov 25–30, 2024",
      category: "Finance & Decision Making"
    },
    {
      id: 5,
      title: "Generative AI",
      organizer: "IMARTICUS LEARNING",
      collaboration: "Skill India & NSDC",
      type: "Faculty Development Program",
      mode: "Online",
      duration: "2 Days",
      date: "June 28–29, 2024",
      category: "Generative AI"
    },
    {
      id: 6,
      title: "Intellectual Property Rights in the Age of AI, ML, Cyber Security & Blockchain",
      organizer: "Mangalmay Institute of Management & Technology, Greater Noida",
      type: "Faculty Development Program",
      mode: "Online",
      duration: "5 Days",
      date: "June 24–28, 2024",
      category: "IPR & Emerging Technologies"
    },
    {
      id: 7,
      title: "Advances in Finance",
      organizer: "FORE School of Management, New Delhi",
      type: "Faculty Development Program",
      mode: "Offline",
      duration: "2 Days",
      date: "May 14–15, 2015",
      category: "Finance"
    },
    {
      id: 8,
      title: "Enhancing Teaching Skills in Personal and Institutional Finance",
      organizer: "FORE School of Management, New Delhi",
      type: "Faculty Development Program",
      mode: "Offline",
      duration: "2 Days",
      date: "May 29–30, 2014",
      category: "Teaching & Finance"
    },
    {
      id: 9,
      title: "The Future of Finance",
      organizer: "I.T.S Mohan Nagar",
      type: "Faculty Development Program",
      mode: "Offline",
      duration: "1 Day",
      date: "May 17, 2013",
      category: "Finance"
    },
    {
      id: 10,
      title: "Financial Derivatives",
      organizer: "Indian Institute of Management (IIM), Kozhikode",
      type: "Faculty Development Program",
      mode: "Offline",
      duration: "6 Days",
      date: "July 09–14, 2007",
      category: "Finance & Derivatives"
    }

  ];


  // -------- UI Section Starts --------
  return (
    <section className="research" id="research">
      <div className="container">

        {/* Header */}
        <div className="section-header">
          <h2 className="section-title">Research & Conferences</h2>
          <p className="section-subtitle">
            A comprehensive summary of academic research and professional contributions.
          </p>
        </div>

        {/* ---- TAB NAVIGATION ---- */}
        <div className="research-tabs">
          <button className={`tab-btn ${activeTab === "publications" ? "active" : ""}`}
            onClick={() => setActiveTab("publications")}>
            Research Publications
          </button>

          <button className={`tab-btn ${activeTab === "conferences" ? "active" : ""}`}
            onClick={() => setActiveTab("conferences")}>
            Conferences
          </button>

          <button className={`tab-btn ${activeTab === "fdpData" ? "active" : ""}`}
            onClick={() => setActiveTab("fdpData")}>
            FDP
          </button>
        </div>

        {/* ---- TAB CONTENT: PUBLICATIONS ---- */}
        {activeTab === "publications" && (
          <div className="publications-section">
            <h3 className="section-heading"><span className="heading-icon">📚</span> Research Publications</h3>

            <div className="publications-list">
              {publications.map((pub, idx) => (
                <div key={pub.id} className="publication-card" data-aos="fade-up" data-aos-delay={idx * 50}>
                  <div className="pub-category">{pub.category}</div>
                  <h4 className="pub-title">{pub.title}</h4>
                  <p className="pub-authors">{pub.authors}</p>
                  <div className="pub-details">
                    <span>{pub.journal}</span>
                    <span>{pub.volume}</span>
                    <span>{pub.year}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ---- TAB CONTENT: CONFERENCES ---- */}
        {activeTab === "conferences" && (
          <div className="presentations-section">
            <h3 className="section-heading"><span className="heading-icon">🎤</span> Conference Presentations</h3>

            <div className="presentations-list">
              {presentations.map((pres, idx) => (
                <div key={pres.id} className="presentation-card" data-aos="fade-up" data-aos-delay={idx * 50}>
                  <div className="pres-type">{pres.type}</div>
                  <h4 className="pres-title">{pres.title}</h4>
                  <div className="pres-details">
                    <span>{pres.event}</span>
                    <span>{pres.venue}</span>
                    <span>{pres.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ---- TAB CONTENT: FDP ---- */}
        {activeTab === "fdpData" && (
          <div className="experience-section">
            <h3 className="section-heading">
              <span className="heading-icon">🎓</span> Faculty Development Programs
            </h3>

            <div className="experience-list">
              {fdpData.map((fdp, idx) => (
                <div
                  key={fdp.id}
                  className="experience-card"
                  data-aos="fade-up"
                  data-aos-delay={idx * 70}
                >
                  <div className="exp-category">{fdp.category}</div>
                  <h4 className="exp-role">{fdp.title}</h4>
                  <p className="exp-company">{fdp.organizer}</p>
                  <span className="exp-period">{fdp.date}</span>
                </div>
              ))}
            </div>
          </div>
        )}



      </div>
    </section>
  );
};

export default Research;
